import React from 'react';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';

import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioCfdi from '../servicios/ServicioCfdi';
import servicioArchivos from '../servicios/ServicioArchivos';
import servicioFormatos from '../servicios/ServicioFormatos';

export class BuscarFacturaCancelada extends React.Component {

    constructor() {
        super();
        this.state = {
            inicio: 0,
            paginacion: {
                registrosPorPagina: 20
            },
            inicio: 0,
            restricciones: {},
            errores: {},
            paginacionHijo: {
                registrosPorPagina: 2
            }
        };
    }

    obtenerResultados = () => {
        this.agregarRestriccionSesion();
        const { paginacion } = this.state;
        servicioCfdi.paginacion(paginacion).then((response) => {
            this.setState({ paginacion: response.data.objeto });
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
        });
    }

    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
    }

    buscar = () => {
        let { restricciones, paginacion } = this.state;
        try {
            if (servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.folio))
                throw new Error('folio requerido');

            if (servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.serie))
                throw new Error('serie requerido');

            paginacion['restriccionesDinamicas'] = [{
                tipoRestriccion: "eq", nombrePropiedad: "alias_ttCfdi.folio",
                valorPropiedad: restricciones.folio
            }, {
                tipoRestriccion: "eq", nombrePropiedad: "alias_ttCfdi.serie",
                valorPropiedad: restricciones.serie
            }];

            this.setState({paginacionHijo: {registrosPorPagina: 2}});

            servicioCfdi.paginacion_admin(paginacion).then((response) => {
                this.setState({ paginacion: response.data.objeto });
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            });


        } catch (error) {
            console.error('outer', error.message);
            this.growl.show({ severity: "error", summary: "", detail: error.message });
        }

    }

    descargaRepresentacionImpresa = (rowData, column) => {
        return <div>
            <div>
                <Button type="button" icon="pi-md-file-download" className="p-button-danger" name="pdf"
                    tooltip="Descargar pdf" onClick={(e) => this.generaDescarga(column.rowData, 'pdf')} >
                </Button>
            </div>
        </div>;
    }

    descargaXmlSaT = (rowData, column) => {
        return <div>
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-file-download" className="p-button-success" name="xml"
                    tooltip="Descargar xml" onClick={(e) => this.generaDescarga(column.rowData, 'xml')} >
                </Button>
            </div>
        </div>;
    }

    generaDescarga(objeto, tipo) {
        servicioArchivos.descargaArchivo('/documentos/descargar_documentos.json?uuid=' + objeto.ttCfdi.uuid + '&tipo=' + tipo);

    }

    columnaTotal = (rowData, column) => {
        return <div>{servicioFormatos.formatearModena(rowData.ttCfdi.total)}</div>;
    }


    columnaFechaCreacion = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.ttCfdi.fechaCreacion)}</div>;
    }

    columnaEstatus = (rowData, column) => {
        if (rowData.ttCfdi.estado === 1)
            return <p>Activo</p>
        if (rowData.ttCfdi.estado === 2)
            return <p>Cancelado</p>
    }

    columnaTipoComprobante = (rowData, column) => {
        if (rowData.ttCfdi.tipoFactura === 0)
            return <p>Factura de pagos</p>
        if (rowData.ttCfdi.tipoFactura === 1)
            return <p>Factura de emergencia</p>
        if (rowData.ttCfdi.tipoFactura === 2)
            return <p>Factura de Peaje</p>
        if (rowData.ttCfdi.tipoFactura === 3)
            return <p>Factura reexpedida</p>
        if (rowData.ttCfdi.tipoFactura === 4)
            return <p>Ingresos diversos</p>
        if (rowData.ttCfdi.tipoFactura === 5)
            return <p>Ingresos diversos/Nota de crédito</p>
        if (rowData.ttCfdi.tipoFactura === 6)
            return <p>Nota de crédito</p>

    }

    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerResultados();
    }

    buscarFacturaHijo = () => {

        let { paginacion } = this.state;

        let paginacionHijo = { registrosPorPagina: 20, datos: [] };
        console.log(paginacion.datos[0].ttCfdi.id)

        paginacionHijo['restriccionesDinamicas'] = [{
            tipoRestriccion: "eq", nombrePropiedad: "alias_ttCfdi.ttCfdi.id",
            valorPropiedad: paginacion.datos[0].ttCfdi.id
        }];

       
        servicioCfdi.paginacion_admin(paginacionHijo).then((response) => {
            this.setState({ paginacionHijo: response.data.objeto });
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
        });

    }


    render() {
        let { restricciones, paginacion, inicio, paginacionHijo } = this.state;
        return (<div>
            <Growl ref={(el) => this.growl = el} />
            <div className="p-fluid">
                <div className="card">
                    <div className="p-grid">
                        <div className="p-col-12">
                            <h1>Consulta Factura cancelada</h1>
                            <p>En esta sección usted puede consultar la factura cancelada.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <h1></h1>
                <div className="p-grid">
                    <div className="p-col-12 p-md-4">
                        <span className="md-inputfield">
                            <InputText type="search" id="restricciones.folio" name="restricciones.folio" value={restricciones.folio || ''} onChange={this.asignarValoresObjeto}></InputText>
                            <label>* Folio:</label>
                        </span>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <span className="md-inputfield">
                            <InputText  type="search" id="restricciones.serie" name="restricciones.serie" value={restricciones.serie || ''} onChange={this.asignarValoresObjeto}></InputText>
                            <label>* Serie:</label>
                        </span>
                    </div>
                    <div className="p-col-12 p-md-3">
                        <Button label="Buscar" icon="pi-md-search" className="p-button-success" onClick={this.buscar} />
                    </div>
                </div>
            </div>

            <div className="content-section implementation">
                <DataTable value={paginacion.datos} editable={true} scrollable={true} scrollHeight="280px" responsive={true} header="Mis facturas de peaje">
                    <Column header="Descarga Pdf" body={this.descargaRepresentacionImpresa.bind(this)} style={{ width: '80px' }} />
                    <Column header="Descarga Xml" body={this.descargaXmlSaT.bind(this)} style={{ width: '80px' }} autoLayout={true} />
                    <Column field="ttCfdi.uuid" header="UUID" style={{ width: '200px' }} autoLayout={true} />
                    <Column body={this.columnaTotal} header="Total" style={{ width: '200px' }} autoLayout={true} />
                    <Column field="ttCfdi.folio" header="Folio" style={{ width: '200px' }} autoLayout={true} />
                    <Column field="ttCfdi.serie" header="Serie" style={{ width: '200px' }} autoLayout={true} />
                    <Column body={this.columnaFechaCreacion} header="Fecha Creacion" style={{ width: '200px' }} autoLayout={true} />
                    <Column field="tcEmisor.rfc" header="R.F.C. Emisor" style={{ width: '200px' }} autoLayout={true} />
                    <Column field="tcReceptor.rfc" header="R.F.C. Receptor" style={{ width: '200px' }} autoLayout={true} />
                    <Column body={this.columnaEstatus} header="Estatus" style={{ width: '200px' }} autoLayout={true} />
                    <Column body={this.columnaTipoComprobante} header="Tipo Comprobante" style={{ width: '200px' }} autoLayout={true} />
                </DataTable>
                <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
            </div>


            <div className="p-col-12">
                {(paginacion.datos != null && paginacion.datos.length > 0) ? <Button label="Buscar Factura Hijo" icon="pi-md-search" className="p-button-success" onClick={this.buscarFacturaHijo} /> : ""}
            </div>


            {paginacionHijo.datos != null && paginacionHijo.datos.length > 0 ? <div className="content-section implementation">
                <DataTable value={paginacionHijo.datos} editable={true} scrollable={true} scrollHeight="280px" responsive={true} header="Mis facturas de peaje">
                    <Column header="Descarga Pdf" body={this.descargaRepresentacionImpresa.bind(this)} style={{ width: '80px' }} />
                    <Column header="Descarga Xml" body={this.descargaXmlSaT.bind(this)} style={{ width: '80px' }} autoLayout={true} />
                    <Column field="ttCfdi.uuid" header="UUID" style={{ width: '200px' }} autoLayout={true} />
                    <Column body={this.columnaTotal} header="Total" style={{ width: '200px' }} autoLayout={true} />
                    <Column field="ttCfdi.folio" header="Folio" style={{ width: '200px' }} autoLayout={true} />
                    <Column field="ttCfdi.serie" header="Serie" style={{ width: '200px' }} autoLayout={true} />
                    <Column body={this.columnaFechaCreacion} header="Fecha Creacion" style={{ width: '200px' }} autoLayout={true} />
                    <Column field="tcEmisor.rfc" header="R.F.C. Emisor" style={{ width: '200px' }} autoLayout={true} />
                    <Column field="tcReceptor.rfc" header="R.F.C. Receptor" style={{ width: '200px' }} autoLayout={true} />
                    <Column body={this.columnaEstatus} header="Estatus" style={{ width: '200px' }} autoLayout={true} />
                    <Column body={this.columnaTipoComprobante} header="Tipo Comprobante" style={{ width: '200px' }} autoLayout={true} />
                </DataTable>
               
            </div>
                : ""
            }

        </div>);
    }
}  